import React from 'react';
import { useCountdown } from '../hooks/useCountdown';
export function OfferCountdown() {
  const {
    minutes,
    seconds
  } = useCountdown(15 * 60 - 27);
  return <div className="offer-card rounded-2xl px-6 py-7 text-center" data-id="element-86" data-mp="203zgp16m6ko4">
      <p className="font-display text-[22px] font-semibold tracking-[-0.01em] text-white" data-id="element-87" data-mp="24y3p7ovj30rb">
        Offerta valida <span className="underline decoration-2 underline-offset-4" data-id="element-88" data-mp="28xw0i9cb3l0d">solo per oggi</span>!
      </p>

      <p className="mx-auto mt-3 max-w-[300px] text-[14.5px] leading-[1.55] text-white/90" data-id="element-89" data-mp="1c9pnoz58dmb0">
        Il tuo prezzo è bloccato per <span className="font-semibold text-white" data-id="element-90" data-mp="1h9c2ve4mdcmg">15 minuti</span>. Se
        non completi l’ordine,{' '}
        <span className="font-semibold text-white" data-id="element-91" data-mp="1lb5xb4o81ke6">il carrello si azzera</span>.
      </p>

      <div className="mt-6 flex items-start justify-center gap-3" data-id="element-92" data-mp="1q5tgco0ghmld">
        <TimeBox value={minutes} label="Minuti" data-id="element-93" data-mp="2wn6r4xzxzz0s" />
        <TimeBox value={seconds} label="Secondi" data-id="element-94" data-mp="31n2yn77um8l3" />
      </div>
    </div>;
}
type TimeBoxProps = {
  value: string;
  label: string;
};
function TimeBox({
  value,
  label
}: TimeBoxProps) {
  return <div className="w-[92px]" data-id="element-95" data-mp="21qqb8s0vnoxk">
      <div className="rounded-xl bg-white px-3 py-3.5" data-id="element-96" data-mp="21qgiiwog73o6">
        <p className="font-display text-[30px] font-semibold leading-none tracking-[-0.02em] text-gold-500" data-id="element-97" data-mp="21ovt1lgzqax6">
          {value}
        </p>
      </div>
      <p className="mt-2 text-[13px] text-white/90" data-id="element-98" data-mp="1rrirnn3juy20">{label}</p>
    </div>;
}